import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { NavigationItem } from '../../../types/navigationItem';
import { Navigation } from '../../../types/navigation';
import { MainLink } from './mainLink';
import { FaBars } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';
import { MobileNavs } from './mobileNavs';
import { VLink } from '../../other/vLink';
import { DesktopNavBar } from './desktopNavBar';

const LinkList = styled.ul`
  @media (max-width: 1080px) {
    display: none;
  }
`;

const MobileSideBar = styled.div<{ open: boolean }>(({ open }) => `
  transition: 0.3s;

  @media (min-width: 1080px) {
    display: none;
  }

  ${!open && `
    transform: translateX(-100%);
  `}
`);

const MobileNav = styled.div`
  @media (min-width: 1081px) {
    display: none;
  }
`;

const Logo = styled.img`
  max-width: 160px;
`;

export interface HeaderProps {
  logo: Asset;
  navigationItems: NavigationItem[];
  navigation: object[];
  disableInverse?: boolean;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const { logo, navigation, disableInverse } = props;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (sidebarOpen) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.removeProperty('overflow');
    }
  }, [sidebarOpen]);

  function toggleSidebar() {
    setSidebarOpen(!sidebarOpen);
  }

  return (
    <>
      <MobileSideBar open={sidebarOpen} className="fixed top-0 bottom-0 left-0 right-0 z-20 overflow-auto bg-neutral">
        <div className="flex justify-between h-20 pl-10 pr-6 text-2xl">
          <VLink className="self-center" to="/">
            {logo &&
            <Logo src={logo.url} alt={logo.name} />
            }
          </VLink>
          <div className="self-center w-5" onClick={toggleSidebar}>
            <svg viewBox="0 0 372.10001 372.04999">
              <path
                id="path74"
                d="m 221.45,186.05 143.3,-143.3 c 9.8,-9.8 9.8,-25.6 0,-35.4 -9.8,-9.8 -25.6,-9.8 -35.4,0 L 186.05,150.65 42.75,7.35 c -9.8,-9.8 -25.6,-9.8 -35.4,0 -9.8,9.8 -9.8,25.6 0,35.4 l 143.3,143.3 -143.3,143.3 c -9.8,9.8 -9.8,25.6 0,35.4 4.9,4.9 11.3,7.3 17.7,7.3 6.4,0 12.8,-2.4 17.7,-7.3 l 143.3,-143.3 143.3,143.3 c 4.9,4.9 11.3,7.3 17.7,7.3 6.4,0 12.8,-2.4 17.7,-7.3 9.8,-9.8 9.8,-25.6 0,-35.4 z"
              />
            </svg>
          </div>
        </div>

        <MobileNavs navigation={navigation} />

      </MobileSideBar>
      <DesktopNavBar disableInverse={true}>
        <VLink to="/">
          {logo &&
            <Logo src={logo.url} alt={logo.name} />
          }
        </VLink>

        <LinkList>
          {navigation && navigation.map((navigationItem, index) => (
            <MainLink key={index} navigationItem={navigationItem} />
          ))}
        </LinkList>

        <MobileNav className="text-2xl text-black" onClick={toggleSidebar}>
          <div>
            <svg className="w-6" viewBox="0 0 487.10068 350">
            <g
              transform="translate(-396.4,-337)"
              id="g158"
            >
              <path
                id="path156"
                d="M 858.6,387 H 421.4 c -13.8,0 -25,-11.2 -25,-25 0,-13.8 11.2,-25 25,-25 h 437.1 c 13.8,0 25,11.2 25,25 0,13.8 -11.1,25 -24.9,25 z"
              />
            </g>
            <g
                transform="translate(-396.4,-337)"
                id="g162"
            >
              <path
                id="path160"
                d="M 858.6,537 H 421.4 c -13.8,0 -25,-11.2 -25,-25 0,-13.8 11.2,-25 25,-25 h 437.1 c 13.8,0 25,11.2 25,25 0.1,13.8 -11.1,25 -24.9,25 z"
              />
            </g>
            <g
                transform="translate(-396.4,-337)"
                id="g166"
            >
              <path
                id="path164"
                d="M 858.6,687 H 421.4 c -13.8,0 -25,-11.2 -25,-25 0,-13.8 11.2,-25 25,-25 h 437.1 c 13.8,0 25,11.2 25,25 0,13.8 -11.1,25 -24.9,25 z"
              />
            </g>
          </svg>
        </div>
        </MobileNav>
      </DesktopNavBar>
    </>
  );
};
